export enum TaskStatusEnum {
  OnTime = "on-time", // a l'heure, pas faite
  Done = "done", // terminée
  DoneLate = "done-late", // terminée en retard
  Late = "late", // en retard non faite
  Postponed = "postponed", // repousée
}
